module.exports = __webpack_public_path__ + "static/71888b4d-cd66-4c8b-9a5c-b37014e8e4fa-64ba639992d5a0326f7168c96a0d4c8b.eot";